import { Schemas } from '@api-client/generated/types';

import BillingServicesList from '../../services-list/BillingServicesList';

type BillingTabDetailsProps = {
  dataSource: Schemas.InvoiceItem[];
  onAdd: VoidFunction;
  onEdit: (details: Schemas.InvoiceItem, index: number) => void;
  onDelete: (index: number) => void;
  canManageServices: boolean;
};

const BillingTabDetails = ({
  dataSource,
  onAdd,
  onEdit,
  onDelete,
  canManageServices,
}: BillingTabDetailsProps) => (
  <BillingServicesList
    dataSource={dataSource}
    onEdit={onEdit}
    onDelete={onDelete}
    onAdd={onAdd}
    canManageServices={canManageServices}
  />
);

export default BillingTabDetails;
